import Auth from "./auth.vue";
export default Auth;
